import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { isGamesTheme } from "@utils";
import AccountStatementBettingTableItem from "./AccountStatementBettingTableItem";
import { BettingActivityReviewReportDto } from "@api-types/reports/ReportResultDto";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";

export default observer(function AccountStatementBettingTable() {
	const { t } = useTranslation();

	const store = useAccountStatementStore();

	if (
		!store.bettingAndPaymentTableData ||
		!store.bettingAndPaymentTableData.bettingActivity?.length
	) {
		return null;
	}

	if (isGamesTheme()) {
		return null;
	}

	return (
		<>
			<thead className="table__head table__head--accent">
				<tr className="table__head__row table__row">
					<th
						className="table__head__cell table__cell table__cell--sml u-type--center"
						colSpan={6}
					>
						{t<string>("ACC_STATEMENT.TABLES.TABLE_BETTING")}
					</th>
				</tr>
			</thead>
			<tbody className="table__body">
				<tr className="table__body__row table__row">
					<td className="table__body__cell table__cell table__cell--sml table__cell--icon-only"></td>
					<td className="table__body__cell table__cell table__cell--sml u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_BETS_NMBR")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_STAKE")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_GAIN")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_NETGAIN")}
					</td>
					<td className="table__body__cell table__cell table__cell--sml u-type--right u-type--wgt--medium">
						{t<string>("ACC_STATEMENT.TABLES.TABLE_LOSS")}
					</td>
				</tr>
				{store.bettingAndPaymentTableData.bettingActivity.map(
					(item: BettingActivityReviewReportDto, index: number) => (
						<AccountStatementBettingTableItem
							tableItem={item}
							key={index}
						/>
					)
				)}
			</tbody>
		</>
	);
});
